import * as React from 'react';
import { useDispatch } from 'react-redux';
import { checkSuburbanEstimationExists } from '../../../actions/checkEstimationExists';

import { openSuburbanDataPaymentForm } from '../../../actions/dataPayment';
import { TThunkDispatch } from '../../../types/redux';

/**
 * Вызываем апи оценки на текущей странице с новыми фильтрами
 * - пользователь изменил основные фильтры и нажал оценить
 */
export function useHandleSuburbanValuationSubmit() {
  const dispatch = useDispatch<TThunkDispatch>();

  return React.useCallback(async () => {
    const isEstimationExists = await dispatch(checkSuburbanEstimationExists());

    if (!isEstimationExists) {
      return;
    }

    dispatch(openSuburbanDataPaymentForm());
  }, [dispatch]);
}
